<div class="row new_mss main-section-starts">
    <div class="col-lg-12">
        <div class="row">
            <!-- <div class="col-lg-12 mb-3">
                <div class="row justify-content-end dropdown-row">
                    <div class="col-lg-3 col-md-3 col-sm-4 col-6 ">
                        <nz-select style="min-width: 150px;" class="w-100" nzPlaceHolder="Select Location"
                            [(ngModel)]="selectedLocation" (ngModelChange)="locationChange($event)">
                            <nz-option nzLabel="All" nzValue="all"></nz-option>
                            <nz-option *ngFor="let location of locations" [nzLabel]="location.name"
                                [nzValue]="location._id"></nz-option>
                        </nz-select>
                    </div>

                    <div class="col-lg-3 col-md-3 col-sm-4 col-6">
                        <nz-select style="min-width: 150px;" class="w-100" nzPlaceHolder="Select Option"
                            [(ngModel)]="selectedDate" (ngModelChange)="dateChange($event)">
                            <nz-option nzLabel="Today" nzValue="today"></nz-option>
                            <nz-option nzLabel="Yesterday" nzValue="yesterday"></nz-option>
                            <nz-option nzLabel="Last 7 days" nzValue="last 7 days"></nz-option>
                            <nz-option nzLabel="This Month" nzValue="this month"></nz-option>
                            <nz-option nzLabel="Last Month" nzValue="last month"></nz-option>
                            <nz-option nzLabel="Fiscal Year" nzValue="fiscal year"></nz-option>
                        </nz-select>
                    </div>
                </div>
            </div> -->

            <div class="col-12  SalesAnalytics-info">
                <nz-card>
                    <div class="row SalesAnalytics-details">
                        <div class="col-lg-12 heading-info">
                            <h4>Purchase Analytics</h4>
                        </div>
                    </div>

                    <div class="row" style="justify-content: space-evenly;">
                        <div class="col-xl-3 col-lg-12 mb-3 ">
                            <div class="TotalSales-count detail-card">
                                <div class="">
                                    <img src="../../../assets/admin-panel/Dashboard/icon.svg" alt="">
                                </div>
                                <div class="text-info">
                                    <h5 class="m-b-0 text-muted">Total Purchase</h5>
                                    <h2 class="m-b-0"> {{purChaseDetails?.length == 0 ? '0' :
                                        (purChaseDetails[0]?.totalPurchases).toFixed(2)}}</h2>
                                </div>
                            </div>
                        </div>

                        <div class="col-xl-3 col-lg-12 mb-3 ">
                            <div class="TotalPurchase-count detail-card">
                                <div class="">
                                    <img src="../../../assets/admin-panel/Dashboard/icon-1.svg" alt="">
                                </div>
                                <div class="text-info">
                                    <h5 class="m-b-0 text-muted">Total Payment</h5>
                                    <h2 class="m-b-0"> {{purChaseDetails?.length == 0 ? '0' :
                                        (purChaseDetails[0]?.totalPayments).toFixed(2)}}</h2>
                                </div>
                            </div>
                        </div>

                        <div class="col-xl-3 col-lg-12 ">
                            <div class="TotalExpenses-count detail-card">
                                <div class="">
                                    <img src="../../../assets/admin-panel/Dashboard/icon-2.svg" alt="">
                                </div>
                                <div class="text-info">
                                    <h5 class="m-b-0 text-muted">Outstanding</h5>
                                    <h2 class="m-b-0"> {{ purChaseDetails?.length == 0 ? '0' :
                                        (purChaseDetails[0]?.outstandingPayable).toFixed(2)}}</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- </div> -->

                </nz-card>
            </div>
        </div>
    </div>
</div>



<div class="row  main-section-starts">
    <div class="col-lg-12">
        <div class="row new_row">
            <img class="img-fluid new_welcome_image" src="../../../assets/images/dashboard/Artboard 1.svg"
            alt="welcome">

            <h2 class="nh2">Welcome to BP Portal</h2>
        </div>
    </div>
</div>




<ngx-spinner bdColor="rgba(35,35,38,0.84)" size="medium" color="#ff0000" type="line-scale" [fullScreen]="true">
</ngx-spinner>